// import React, { useState, useEffect } from 'react';
// import { useSelector } from 'react-redux';
// import '../../Styles/ManagementPages.css';
// import '../../Styles/CustomerManage.css';
// import { getDrivers } from '../../Services/Operations/ProductAPI';

// const DriverManagement = () => {
//   const { token } = useSelector(state => state.user);
//   const [drivers, setDrivers] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [editingDriver, setEditingDriver] = useState(null);
//   const [editForm, setEditForm] = useState({});
//   const [viewingDriver, setViewingDriver] = useState(null);
//   const [error, setError] = useState(null);

//   // Pagination states
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [totalDrivers, setTotalDrivers] = useState(0);
//   const [pageSize] = useState(10);

//   // Calculate starting index for sequential numbering
//   const getSequentialNumber = (index) => {
//     return (currentPage - 1) * pageSize + index + 1;
//   };

//   // Fetch drivers on page or search change
//   useEffect(() => {
//     const delayDebounceFn = setTimeout(() => {
//       fetchDrivers();
//     }, 500);

//     return () => clearTimeout(delayDebounceFn);
//   }, [currentPage, searchTerm]);

//   const fetchDrivers = async () => {
//     try {
//       setLoading(true);
//       const response = await getDrivers(token, currentPage, pageSize, searchTerm);

//       if (response && response.drivers) {
//         const transformedDrivers = response.drivers.map((driver, index) => ({
//           id: driver._id,
//           serialNo: getSequentialNumber(index),
//           profileImage: driver.profileImage,
//           name: driver.name || '',
//           mobileNumber: driver.mobileNumber || '',
//           licenseNumber: driver.licenseNumber || '',
//           experience: driver.experience || 0,
//           assignedBus: driver.assignedBus || null,
//           busOwner: driver.busOwner || null,
//           isActive: driver.isActive || false,
//           joined: new Date(driver.createdAt).toISOString().split('T')[0],
//           status: driver.isActive ? 'Active' : 'Inactive',
//         }));

//         setDrivers(transformedDrivers);
//         setTotalPages(response.totalPages || 1);
//         setTotalDrivers(response.total || 0);
//       }
//     } catch (err) {
//       setError('Failed to fetch drivers.');
//       console.error('Error fetching drivers:', err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleViewDriver = (driver) => {
//     setViewingDriver({
//       ...driver,
//       name: driver.name || '',
//       mobileNumber: driver.mobileNumber || '',
//       licenseNumber: driver.licenseNumber || '',
//       experience: driver.experience || 0,
//       isActive: driver.isActive,
//       assignedBus: driver.assignedBus,
//       busOwner: driver.busOwner,
//       profileImage: driver.profileImage,
//       joined: driver.joined,
//     });
//   };

//   const handleSearchChange = (e) => {
//     setSearchTerm(e.target.value);
//     setCurrentPage(1);
//   };

//   const filteredDrivers = drivers.filter(driver =>
//     (driver.name && driver.name.toLowerCase().includes(searchTerm.toLowerCase())) ||
//     (driver.mobileNumber && driver.mobileNumber.includes(searchTerm)) ||
//     (driver.licenseNumber && driver.licenseNumber.toLowerCase().includes(searchTerm.toLowerCase())) ||
//     (driver.busOwner?.name && driver.busOwner.name.toLowerCase().includes(searchTerm.toLowerCase()))
//   );

//   const handleExportCSV = () => {
//     if (filteredDrivers.length === 0) {
//       alert('No data to export');
//       return;
//     }

//     const headers = ['Serial No.', 'ID', 'Name', 'Mobile', 'License', 'Experience', 'Bus Owner', 'Assigned Bus', 'Status', 'Joined'];
//     const csvData = filteredDrivers.map(driver => [
//       driver.serialNo,
//       driver.id,
//       driver.name || '',
//       driver.mobileNumber || '',
//       driver.licenseNumber || '',
//       driver.experience,
//       driver.busOwner?.name || 'N/A',
//       driver.assignedBus?.busNumber || 'N/A',
//       driver.status,
//       driver.joined
//     ]);

//     const csvContent = [
//       headers.join(','),
//       ...csvData.map(row => row.map(field => `"${field}"`).join(','))
//     ].join('\n');

//     const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
//     const url = window.URL.createObjectURL(blob);
//     const link = document.createElement('a');
//     link.href = url;
//     link.download = `drivers-report-${new Date().toISOString().split('T')[0]}.csv`;
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//     window.URL.revokeObjectURL(url);

//     alert('CSV exported successfully!');
//   };

//   const handleEditDriver = (driver) => {
//     setEditingDriver(driver.id);
//     setEditForm({
//       name: driver.name || '',
//       mobileNumber: driver.mobileNumber || '',
//       licenseNumber: driver.licenseNumber || '',
//       experience: driver.experience || 0,
//       status: driver.status
//     });
//   };

//   const handleSaveEdit = async () => {
//     try {
//       setError(null);
      
//       // TODO: Implement updateDriver API call
//       // const updateData = {
//       //   name: editForm.name,
//       //   mobileNumber: editForm.mobileNumber,
//       //   licenseNumber: editForm.licenseNumber,
//       //   experience: editForm.experience,
//       //   isActive: editForm.status === 'Active'
//       // };
//       // 
//       // const response = await updateDriver(editingDriver, updateData, token);
      
//       // For now, update locally
//       setDrivers(prevDrivers =>
//         prevDrivers.map(driver =>
//           driver.id === editingDriver ? {
//             ...driver,
//             name: editForm.name,
//             mobileNumber: editForm.mobileNumber,
//             licenseNumber: editForm.licenseNumber,
//             experience: editForm.experience,
//             status: editForm.status,
//             isActive: editForm.status === 'Active'
//           } : driver
//         )
//       );

//       setEditingDriver(null);
//       setEditForm({});
//       alert('Driver updated successfully!');
//     } catch (err) {
//       console.error('Error updating driver:', err);
//       setError('Failed to update driver. Please try again.');
//       alert('Failed to update driver. Please try again.');
//     }
//   };

//   const handleCancelEdit = () => {
//     setEditingDriver(null);
//     setEditForm({});
//     setError(null);
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setEditForm(prev => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   const closeViewModal = () => {
//     setViewingDriver(null);
//   };

//   const handleRefresh = () => {
//     setCurrentPage(1);
//     fetchDrivers();
//   };

//   const handleNextPage = () => {
//     if (currentPage < totalPages) {
//       setCurrentPage(prev => prev + 1);
//     }
//   };

//   const handlePrevPage = () => {
//     if (currentPage > 1) {
//       setCurrentPage(prev => prev - 1);
//     }
//   };

//   const handlePageClick = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

//   if (loading) {
//     return (
//       <div className="management-page">
//         <div className="loading-container">
//           <p>Loading drivers...</p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="management-page">
//       <div className="page-header">
//         <h1>Driver Management</h1>
//         <div className="header-actions">
//           <input
//             type="text"
//             placeholder="Search drivers by name, mobile, license or bus owner..."
//             className="search-input"
//             value={searchTerm}
//             onChange={handleSearchChange}
//           />
//           <button className="refresh-btn" onClick={handleRefresh}>
//             Refresh
//           </button>
//           <button className="export-btn" onClick={handleExportCSV}>
//             Export CSV
//           </button>
//         </div>
//       </div>

//       {error && (
//         <div className="error-message">
//           {error}
//         </div>
//       )}

//       <div className="stats-cards">
//         <div className="stat-card">
//           <h3>Total Drivers</h3>
//           <p>{totalDrivers || drivers.length}</p>
//           <span>All registered drivers</span>
//         </div>
//         <div className="stat-card">
//           <h3>Active Drivers</h3>
//           <p>{drivers.filter(d => d.status === 'Active').length}</p>
//           <span>Active drivers</span>
//         </div>
//         <div className="stat-card">
//           <h3>With Assigned Bus</h3>
//           <p>{drivers.filter(d => d.assignedBus).length}</p>
//           <span>Drivers with bus assignment</span>
//         </div>
//         <div className="stat-card">
//           <h3>Search Results</h3>
//           <p>{filteredDrivers.length}</p>
//           <span>drivers found</span>
//         </div>
//       </div>

//       <div className="table-container">
//         <table className="data-table">
//           <thead>
//             <tr>
//               <th>No.</th>
//               {/* <th>Profile</th> */}
//               <th>Name</th>
//               <th>Mobile</th>
//               <th>License</th>
//               <th>Experience</th>
//               <th>Bus Owner</th>
//               <th>Assigned Bus</th>
//               <th>Status</th>
//               <th>Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {filteredDrivers.map(driver => (
//               <tr key={driver.id}>
//                 <td>{driver.serialNo}</td>
//                 {/* <td>
//                   <div className="profile-image-cell">
//                     <img
//                       src={driver.profileImage ? 
//                         `${process.env.REACT_APP_BASE_URL}/uploads/${driver.profileImage}` : 
//                         ''}
//                       alt={driver.name || 'Driver'}
//                       className="customer-avatar"
//                       onError={(e) => {
//                         e.target.onerror = null;
//                         e.target.src = '';
//                       }}
//                     />
//                   </div>
//                 </td> */}
//                 <td>
//                   {editingDriver === driver.id ? (
//                     <input
//                       type="text"
//                       name="name"
//                       value={editForm.name || ''}
//                       onChange={handleInputChange}
//                       className="edit-input"
//                     />
//                   ) : (
//                     driver.name || 'N/A'
//                   )}
//                 </td>
//                 <td>
//                   {editingDriver === driver.id ? (
//                     <input
//                       type="text"
//                       name="mobileNumber"
//                       value={editForm.mobileNumber || ''}
//                       onChange={handleInputChange}
//                       className="edit-input"
//                     />
//                   ) : (
//                     driver.mobileNumber || 'N/A'
//                   )}
//                 </td>
//                 <td>
//                   {editingDriver === driver.id ? (
//                     <input
//                       type="text"
//                       name="licenseNumber"
//                       value={editForm.licenseNumber || ''}
//                       onChange={handleInputChange}
//                       className="edit-input"
//                     />
//                   ) : (
//                     driver.licenseNumber || 'N/A'
//                   )}
//                 </td>
//                 <td>
//                   {editingDriver === driver.id ? (
//                     <input
//                       type="number"
//                       name="experience"
//                       value={editForm.experience || ''}
//                       onChange={handleInputChange}
//                       className="edit-input"
//                     />
//                   ) : (
//                     `${driver.experience} years` || 'N/A'
//                   )}
//                 </td>
//                 <td>
//                   {driver.busOwner?.name || 'N/A'}
//                 </td>
//                 <td>
//                   {driver.assignedBus ? (
//                     <div className="bus-info">
//                       <div><strong>{driver.assignedBus.busNumber}</strong></div>
//                       <small>{driver.assignedBus.busName}</small>
//                     </div>
//                   ) : 'Not Assigned'}
//                 </td>
//                 <td>
//                   {editingDriver === driver.id ? (
//                     <select
//                       name="status"
//                       value={editForm.status || ''}
//                       onChange={handleInputChange}
//                       className="edit-select"
//                     >
//                       <option value="Active">Active</option>
//                       <option value="Inactive">Inactive</option>
//                     </select>
//                   ) : (
//                     <span className={`status-badge ${driver.status ? driver.status.toLowerCase() : 'inactive'}`}>
//                       {driver.status || 'Inactive'}
//                     </span>
//                   )}
//                 </td>
//                 <td>
//                   {editingDriver === driver.id ? (
//                     <div className="edit-actions">
//                       <button className="action-btn save" onClick={handleSaveEdit}>
//                         Save
//                       </button>
//                       <button className="action-btn cancel" onClick={handleCancelEdit}>
//                         Cancel
//                       </button>
//                     </div>
//                   ) : (
//                     <div className="action-buttons">
//                       <button
//                         className="action-btn view"
//                         onClick={() => handleViewDriver(driver)}
//                       >
//                         View
//                       </button>
//                       <button
//                         className="action-btn edit"
//                         onClick={() => handleEditDriver(driver)}
//                       >
//                         Edit
//                       </button>
//                     </div>
//                   )}
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>

//         {filteredDrivers.length === 0 && !loading && (
//           <div className="no-data">
//             <p>No drivers found matching your search.</p>
//           </div>
//         )}
//       </div>

//       <div className="pagination-container">
//         <div className="pagination-info">
//           Showing {drivers.length} of {totalDrivers} drivers (Page {currentPage} of {totalPages})
//         </div>
//         <div className="pagination-controls">
//           <button
//             className="pagination-btn"
//             onClick={handlePrevPage}
//             disabled={currentPage === 1}
//           >
//             Previous
//           </button>

//           <div className="page-numbers">
//             {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
//               let pageNumber;
//               if (totalPages <= 5) {
//                 pageNumber = i + 1;
//               } else if (currentPage <= 3) {
//                 pageNumber = i + 1;
//               } else if (currentPage >= totalPages - 2) {
//                 pageNumber = totalPages - 4 + i;
//               } else {
//                 pageNumber = currentPage - 2 + i;
//               }

//               return (
//                 <button
//                   key={pageNumber}
//                   className={`page-number ${pageNumber === currentPage ? 'active' : ''}`}
//                   onClick={() => handlePageClick(pageNumber)}
//                 >
//                   {pageNumber}
//                 </button>
//               );
//             })}
//           </div>

//           <button
//             className="pagination-btn"
//             onClick={handleNextPage}
//             disabled={currentPage === totalPages}
//           >
//             Next
//           </button>
//         </div>
//       </div>

//       {viewingDriver && (
//         <div className="modal-overlay" onClick={closeViewModal}>
//           <div className="modal-content1" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h3>Driver Details</h3>
//               <button className="modal-close-btn" onClick={closeViewModal}>
//                 ×
//               </button>
//             </div>
//             <div className="modal-body">
//               <div className="customer-details">
//                 <div className="customer-profile-image">
//                   <img
//                     src={viewingDriver.profileImage ? 
//                       `${process.env.REACT_APP_BASE_URL}/uploads/${viewingDriver.profileImage}` : 
//                       ''}
//                     alt={viewingDriver.name || 'Driver'}
//                     className="profile-image-large"
//                     onError={(e) => {
//                       e.target.onerror = null;
//                       e.target.src = '';
//                     }}
//                   />
//                 </div>
//                 <div className="detail-row">
//                   <label>Name:</label>
//                   <span>{viewingDriver.name || 'N/A'}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Mobile Number:</label>
//                   <span>{viewingDriver.mobileNumber || 'N/A'}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>License Number:</label>
//                   <span>{viewingDriver.licenseNumber || 'N/A'}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Experience:</label>
//                   <span>{viewingDriver.experience} years</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Bus Owner:</label>
//                   <span>
//                     {viewingDriver.busOwner ? (
//                       <div className="bus-owner-info">
//                         <strong>{viewingDriver.busOwner.name}</strong>
//                         <small>{viewingDriver.busOwner.phone}</small>
//                       </div>
//                     ) : 'N/A'}
//                   </span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Assigned Bus:</label>
//                   <span>
//                     {viewingDriver.assignedBus ? (
//                       <div className="bus-info">
//                         <strong>{viewingDriver.assignedBus.busNumber}</strong>
//                         <small>{viewingDriver.assignedBus.busName}</small>
//                       </div>
//                     ) : 'Not Assigned'}
//                   </span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Joined Date:</label>
//                   <span>{viewingDriver.joined}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Status:</label>
//                   <span className={`status-badge ${viewingDriver.status ? viewingDriver.status.toLowerCase() : 'inactive'}`}>
//                     {viewingDriver.status || 'Inactive'}
//                   </span>
//                 </div>
//               </div>
//             </div>
//             <div className="modal-footer">
//               <button className="modal-close-btn secondary" onClick={closeViewModal}>
//                 Close
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default DriverManagement;

// import React, { useState, useEffect } from 'react';
// import { useSelector } from 'react-redux';
// import '../../Styles/ManagementPages.css';
// import '../../Styles/CustomerManage.css';
// import { getDrivers, getDriverById, updateDriver } from '../../Services/Operations/ProductAPI';

// const DriverManagement = () => {
//   const { token } = useSelector(state => state.user);
//   const [drivers, setDrivers] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [searching, setSearching] = useState(false);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [editingDriver, setEditingDriver] = useState(null);
//   const [editForm, setEditForm] = useState({});
//   const [viewingDriver, setViewingDriver] = useState(null);
//   const [error, setError] = useState(null);
//   const [isFetchingDetails, setIsFetchingDetails] = useState(false);

//   // Pagination states
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [totalDrivers, setTotalDrivers] = useState(0);
//   const [pageSize] = useState(10);

//   // Calculate starting index for sequential numbering
//   const getSequentialNumber = (index) => {
//     return (currentPage - 1) * pageSize + index + 1;
//   };

//   // Fetch drivers on page or search change
//   useEffect(() => {
//     const delayDebounceFn = setTimeout(() => {
//       fetchDrivers();
//     }, 500);

//     return () => clearTimeout(delayDebounceFn);
//   }, [currentPage, searchTerm]);

// const fetchDrivers = async () => {
//   try {
//     setSearching(true);
//     setLoading(true);
//     const response = await getDrivers(token, currentPage, pageSize, searchTerm);

//       if (response && response.drivers) {
//         const transformedDrivers = response.drivers.map((driver, index) => ({
//           id: driver._id,
//           serialNo: getSequentialNumber(index),
//           profileImage: driver.profileImage,
//           name: driver.name || '',
//           mobileNumber: driver.mobileNumber || '',
//           licenseNumber: driver.licenseNumber || '',
//           experience: driver.experience || 0,
//           assignedBus: driver.assignedBus || null,
//           busOwner: driver.busOwner || null,
//           isActive: driver.isActive || false,
//           joined: new Date(driver.createdAt).toISOString().split('T')[0],
//           status: driver.isActive ? 'Active' : 'Inactive',
//         }));

//         setDrivers(transformedDrivers);
//         setTotalPages(response.totalPages || 1);
//         setTotalDrivers(response.total || 0);
//       }
//     } catch (err) {
//       setError('Failed to fetch drivers.');
//       console.error('Error fetching drivers:', err);
//     } finally {
//   setLoading(false);
//   setSearching(false);
// }
//   };

//   const handleViewDriver = async (driverId) => {
//     try {
//       setIsFetchingDetails(true);
//       setError(null);
      
//       // Fetch detailed driver information
//       const response = await getDriverById(driverId, token);
      
//       if (response.success) {
//         const driver = response.data;
//         setViewingDriver({
//           id: driver._id,
//           name: driver.name || '',
//           mobileNumber: driver.mobileNumber || '',
//           licenseNumber: driver.licenseNumber || '',
//           experience: driver.experience || 0,
//           email: driver.email || '',
//           address: driver.address || '',
//           isActive: driver.isActive,
//           assignedBus: driver.assignedBus || null,
//           busOwner: driver.busOwner || null,
//           profileImage: driver.profileImage,
        
//           createdAt: new Date(driver.createdAt).toLocaleDateString('en-US', {
//             year: 'numeric',
//             month: 'long',
//             day: 'numeric'
//           }),
//           updatedAt: new Date(driver.updatedAt).toLocaleDateString('en-US', {
//             year: 'numeric',
//             month: 'long',
//             day: 'numeric'
//           })
//         });
//       } else {
//         setError('Failed to fetch driver details.');
//       }
//     } catch (err) {
//       console.error('Error fetching driver details:', err);
//       setError('Failed to fetch driver details.');
//     } finally {
//       setIsFetchingDetails(false);
//     }
//   };

//   const handleEditDriver = async (driverId) => {
//     try {
//       setIsFetchingDetails(true);
//       setError(null);
      
//       // Fetch current driver details for editing
//       const response = await getDriverById(driverId, token);
      
//       if (response.success) {
//         const driver = response.data;
//         setEditingDriver(driver._id);
//         setEditForm({
//           name: driver.name || '',
//           mobileNumber: driver.mobileNumber || '',
//           licenseNumber: driver.licenseNumber || '',
          
//           isActive: driver.isActive || true
//         });
//       } else {
//         setError('Failed to fetch driver details for editing.');
//       }
//     } catch (err) {
//       console.error('Error fetching driver details for editing:', err);
//       setError('Failed to fetch driver details for editing.');
//     } finally {
//       setIsFetchingDetails(false);
//     }
//   };

//   const handleSaveEdit = async () => {
//     try {
//       setError(null);
      
//       // Prepare update data
//       const updateData = {
//         name: editForm.name,
//         mobileNumber: editForm.mobileNumber,
//         licenseNumber: editForm.licenseNumber,
//         isActive: editForm.isActive
//       };

//       console.log('Updating driver with data:', updateData);
      
//       const response = await updateDriver(editingDriver, updateData, token);
      
//       if (response.success) {
//         // Update local state
//         setDrivers(prevDrivers =>
//           prevDrivers.map(driver =>
//             driver.id === editingDriver ? {
//               ...driver,
//               name: response.data.name,
//               mobileNumber: response.data.mobileNumber,
//               licenseNumber: response.data.licenseNumber,
//               experience: response.data.experience,
//               status: response.data.isActive ? 'Active' : 'Inactive',
//               isActive: response.data.isActive
//             } : driver
//           )
//         );

//         setEditingDriver(null);
//         setEditForm({});
//         alert('Driver updated successfully!');
//       } else {
//         setError(response.message || 'Failed to update driver.');
//       }
//     } catch (err) {
//       console.error('Error updating driver:', err);
//       setError(err.response?.data?.message || 'Failed to update driver. Please try again.');
//       alert('Failed to update driver. Please try again.');
//     }
//   };

//   const handleCancelEdit = () => {
//     setEditingDriver(null);
//     setEditForm({});
//     setError(null);
//   };

//   const handleInputChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setEditForm(prev => ({
//       ...prev,
//       [name]: type === 'checkbox' ? checked : value
//     }));
//   };

//   const closeViewModal = () => {
//     setViewingDriver(null);
//   };

//   const handleSearchChange = (e) => {
//     setSearchTerm(e.target.value);
//     setCurrentPage(1);
//   };

// const handleRefresh = () => {
//   setSearchTerm('');
//   setCurrentPage(1);
//   // The useEffect will trigger fetchDrivers automatically
// };

//   const handleExportCSV = () => {
//     // ... existing export code ...
//   };

//   const handleNextPage = () => {
//     if (currentPage < totalPages) {
//       setCurrentPage(prev => prev + 1);
//     }
//   };

//   const handlePrevPage = () => {
//     if (currentPage > 1) {
//       setCurrentPage(prev => prev - 1);
//     }
//   };

//   const handlePageClick = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

//     const filteredDrivers = drivers.filter(driver =>
//     (driver.name && driver.name.toLowerCase().includes(searchTerm.toLowerCase())) ||
//     (driver.mobileNumber && driver.mobileNumber.includes(searchTerm)) ||
//     (driver.licenseNumber && driver.licenseNumber.toLowerCase().includes(searchTerm.toLowerCase())) ||
//     (driver.busOwner?.name && driver.busOwner.name.toLowerCase().includes(searchTerm.toLowerCase()))
//   );

//   if (loading && drivers.length === 0) {
//     return (
//       <div className="management-page">
//         <div className="loading-container">
//           <p>Loading drivers...</p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="management-page">
//       <div className="page-header">
//         <h1>Driver Management</h1>
//         <div className="header-actions">
//          <div style={{ position: 'relative' }}>
//   <input
//     type="text"
//     placeholder="Search drivers by name, mobile, license or bus owner..."
//     className="search-input"
//     value={searchTerm}
//     onChange={handleSearchChange}
//     style={{ width: "70%" }}
//   />
//   {searching && (
//     <span style={{
//       position: 'absolute', right: '10px', top: '50%',
//       transform: 'translateY(-50%)', fontSize: '12px', color: '#888'
//     }}>
//       searching...
//     </span>
//   )}
// </div>
//           <button className="refresh-btn" onClick={handleRefresh}>
//             Refresh
//           </button>
//           <button className="export-btn" onClick={handleExportCSV}>
//             Export CSV
//           </button>
//         </div>
//       </div>

//       {error && (
//         <div className="error-message">
//           {error}
//         </div>
//       )}

//        <div className="stats-cards">
//         <div className="stat-card">
//   <h3>Search Results</h3>
//   <p>{drivers.length}</p>
//   <span>drivers found</span>
// </div>
//          <div className="stat-card">
//            <h3>Active Drivers</h3>
//            <p>{drivers.filter(d => d.status === 'Active').length}</p>
//            <span>Active drivers</span>
//          </div>
//          <div className="stat-card">
//            <h3>With Assigned Bus</h3>
//            <p>{drivers.filter(d => d.assignedBus).length}</p>
//            <span>Drivers with bus assignment</span>
//          </div>
//          <div className="stat-card">
//            <h3>Search Results</h3>
//            <p>{filteredDrivers.length}</p>
//            <span>drivers found</span>
//          </div>
//        </div>

//       <div className="table-container">
//         <table className="data-table">
//           <thead>
//             <tr>
//               <th>No.</th>
//               {/* <th>Profile</th> */}
//               <th>Name</th>
//               <th>Mobile</th>
//               <th>License</th>
//               <th>Experience</th>
//               <th>Bus Owner</th>
//               <th>Assigned Bus</th>
//               <th>Status</th>
//               <th>Actions</th>
//             </tr>
//           </thead>
//          <tbody>
//   {drivers.length > 0 ? (
//     drivers.map(driver => (
//               <tr key={driver.id}>
//                 <td>{driver.serialNo}</td>
//                 {/* <td>
//                   <div className="profile-image-cell">
//                     <img
//                       src={driver.profileImage ? 
//                         `${process.env.REACT_APP_BASE_URL}/uploads/${driver.profileImage}` : 
//                         ''}
//                       alt={driver.name || 'Driver'}
//                       className="customer-avatar"
//                       onError={(e) => {
//                         e.target.onerror = null;
//                         e.target.src = '';
//                       }}
//                     />
//                   </div>
//                 </td> */}
//                 <td>
//                   {editingDriver === driver.id ? (
//                     <input
//                       type="text"
//                       name="name"
//                       value={editForm.name || ''}
//                       onChange={handleInputChange}
//                       className="edit-input"
//                       placeholder="Name"
//                     />
//                   ) : (
//                     driver.name || 'N/A'
//                   )}
//                 </td>
//                 <td>
//                   {editingDriver === driver.id ? (
//                     <input
//                       type="text"
//                       name="mobileNumber"
//                       value={editForm.mobileNumber || ''}
//                       onChange={handleInputChange}
//                       className="edit-input"
//                       placeholder="Mobile Number"
//                     />
//                   ) : (
//                     driver.mobileNumber || 'N/A'
//                   )}
//                 </td>
//                 <td>
//                   {editingDriver === driver.id ? (
//                     <input
//                       type="text"
//                       name="licenseNumber"
//                       value={editForm.licenseNumber || ''}
//                       onChange={handleInputChange}
//                       className="edit-input"
//                       placeholder="License Number"
//                     />
//                   ) : (
//                     driver.licenseNumber || 'N/A'
//                   )}
//                 </td>
//                 <td>
//                   {editingDriver === driver.id ? (
//                     <input
//                       type="number"
//                       name="experience"
//                       value={editForm.experience || ''}
//                       onChange={handleInputChange}
//                       className="edit-input"
//                       placeholder="Years"
//                       min="0"
//                     />
//                   ) : (
//                     `${driver.experience} years` || 'N/A'
//                   )}
//                 </td>
//                 <td>
//                   {driver.busOwner?.name || 'N/A'}
//                 </td>
//                 <td>
//                   {driver.assignedBus ? (
//                     <div className="bus-info">
//                       <div><strong>{driver.assignedBus.busNumber}</strong></div>
//                       <small>{driver.assignedBus.busName}</small>
//                     </div>
//                   ) : 'Not Assigned'}
//                 </td>
//                 <td>
//                   {editingDriver === driver.id ? (
//                     <label className="checkbox-label">
//                       <input
//                         type="checkbox"
//                         name="isActive"
//                         checked={editForm.isActive || false}
//                         onChange={handleInputChange}
//                       />
//                       <span className="checkbox-text">
//                         {editForm.isActive ? 'Active' : 'Inactive'}
//                       </span>
//                     </label>
//                   ) : (
//                     <span className={`status-badge ${driver.status ? driver.status.toLowerCase() : 'inactive'}`}>
//                       {driver.status || 'Inactive'}
//                     </span>
//                   )}
//                 </td>
//                 <td>
//                   {editingDriver === driver.id ? (
//                     <div className="edit-actions">
//                       <button className="action-btn save" onClick={handleSaveEdit} disabled={isFetchingDetails}>
//                         {isFetchingDetails ? 'Saving...' : 'Save'}
//                       </button>
//                       <button className="action-btn cancel" onClick={handleCancelEdit} disabled={isFetchingDetails}>
//                         Cancel
//                       </button>
//                     </div>
//                   ) : (
//                     <div className="action-buttons">
//                       <button
//                         className="action-btn view"
//                         onClick={() => handleViewDriver(driver.id)}
//                         disabled={isFetchingDetails}
//                       >
//                         {isFetchingDetails ? 'Loading...' : 'View'}
//                       </button>
//                       <button
//                         className="action-btn edit"
//                         onClick={() => handleEditDriver(driver.id)}
//                         disabled={isFetchingDetails}
//                       >
//                         {isFetchingDetails ? 'Loading...' : 'Edit'}
//                       </button>
//                     </div>
//                   )}
//                 </td>
//               </tr>
//                 ))
//   ) : (
//     <tr>
//       <td colSpan="9" className="no-data">
//         <p>No drivers found {searchTerm ? 'matching your search' : ''}.</p>
//         {searchTerm && (
//           <button className="clear-filters-link" onClick={handleRefresh}>
//             Clear search to see all drivers
//           </button>
//         )}
//       </td>
//     </tr>
//   )}
//           </tbody>
//         </table>

//         {drivers.length === 0 && !loading && (
//           <div className="no-data">
//             <p>No drivers found matching your search.</p>
//           </div>
//         )}
//       </div>

//       {/* Pagination Component */}
//       <div className="pagination-container">
//         <div className="pagination-info">
//   Showing {drivers.length} of {totalDrivers} drivers
//   (Page {currentPage} of {totalPages})
//   {searchTerm && <span className="filtered-indicator"> • Search: "{searchTerm}"</span>}
// </div>
//         <div className="pagination-controls">
//           <button
//             className="pagination-btn"
//             onClick={handlePrevPage}
//             disabled={currentPage === 1}
//           >
//             Previous
//           </button>

//           <div className="page-numbers">
//             {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
//               let pageNumber;
//               if (totalPages <= 5) {
//                 pageNumber = i + 1;
//               } else if (currentPage <= 3) {
//                 pageNumber = i + 1;
//               } else if (currentPage >= totalPages - 2) {
//                 pageNumber = totalPages - 4 + i;
//               } else {
//                 pageNumber = currentPage - 2 + i;
//               }

//               return (
//                 <button
//                   key={pageNumber}
//                   className={`page-number ${pageNumber === currentPage ? 'active' : ''}`}
//                   onClick={() => handlePageClick(pageNumber)}
//                 >
//                   {pageNumber}
//                 </button>
//               );
//             })}
//           </div>

//           <button
//             className="pagination-btn"
//             onClick={handleNextPage}
//             disabled={currentPage === totalPages}
//           >
//             Next
//           </button>
//         </div>
//       </div>

//       {/* View Driver Modal */}
//       {viewingDriver && (
//         <div className="modal-overlay" onClick={closeViewModal}>
//           <div className="modal-content1" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h3>Driver Details</h3>
//               <button className="modal-close-btn" onClick={closeViewModal}>
//                 ×
//               </button>
//             </div>
//             <div className="modal-body">
//               <div className="customer-details">
//                 <div className="customer-profile-image">
//                   <img
//                     src={viewingDriver.profileImage ? 
//                       `${process.env.REACT_APP_BASE_URL}/uploads/${viewingDriver.profileImage}` : 
//                       ''}
//                     alt={viewingDriver.name || 'Driver'}
//                     className="profile-image-large"
//                     onError={(e) => {
//                       e.target.onerror = null;
//                       e.target.src = '';
//                     }}
//                   />
//                 </div>
//                 <div className="detail-row">
//                   <label>Name:</label>
//                   <span>{viewingDriver.name || 'N/A'}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Mobile Number:</label>
//                   <span>{viewingDriver.mobileNumber || 'N/A'}</span>
//                 </div>
              
//                 <div className="detail-row">
//                   <label>License Number:</label>
//                   <span>{viewingDriver.licenseNumber || 'N/A'}</span>
//                 </div>
               
//                 <div className="detail-row">
//                   <label>Experience:</label>
//                   <span>{viewingDriver.experience} years</span>
//                 </div>
               
              
//                 <div className="detail-row">
//                   <label>Bus Owner:</label>
//                   <span>
//                     {viewingDriver.busOwner ? (
//                       <div className="bus-owner-info">
//                         <strong>{viewingDriver.busOwner.name}</strong>
//                         <small>{viewingDriver.busOwner.phone}</small>
//                       </div>
//                     ) : 'N/A'}
//                   </span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Assigned Bus:</label>
//                   <span>
//                     {viewingDriver.assignedBus ? (
//                       <div className="bus-info">
//                         <strong>{viewingDriver.assignedBus.busNumber}</strong>
//                         <small>{viewingDriver.assignedBus.busName}</small>
//                       </div>
//                     ) : 'Not Assigned'}
//                   </span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Created Date:</label>
//                   <span>{viewingDriver.createdAt}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Last Updated:</label>
//                   <span>{viewingDriver.updatedAt}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Status:</label>
//                   <span className={`status-badge ${viewingDriver.isActive ? 'active' : 'inactive'}`}>
//                     {viewingDriver.isActive ? 'Active' : 'Inactive'}
//                   </span>
//                 </div>
//               </div>
//             </div>
//             <div className="modal-footer">
//               <button className="modal-close-btn secondary" onClick={closeViewModal}>
//                 Close
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Edit Form Modal (for more complex edits) */}
//       {editingDriver && (
//         <div className="modal-overlay" onClick={handleCancelEdit}>
//           <div className="modal-content1 edit-modal" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h3>Edit Driver</h3>
//               <button className="modal-close-btn" onClick={handleCancelEdit}>
//                 ×
//               </button>
//             </div>
//             <div className="modal-body">
//               <div className="edit-form">
//                 <div className="form-group">
//                   <label>Name:</label>
//                   <input
//                     type="text"
//                     name="name"
//                     value={editForm.name || ''}
//                     onChange={handleInputChange}
//                     className="form-control"
//                     placeholder="Driver Name"
//                   />
//                 </div>
//                 <div className="form-group">
//                   <label>Mobile Number:</label>
//                   <input
//                     type="text"
//                     name="mobileNumber"
//                     value={editForm.mobileNumber || ''}
//                     onChange={handleInputChange}
//                     className="form-control"
//                     placeholder="Mobile Number"
//                   />
//                 </div>
              
//                 <div className="form-group">
//                   <label>License Number:</label>
//                   <input
//                     type="text"
//                     name="licenseNumber"
//                     value={editForm.licenseNumber || ''}
//                     onChange={handleInputChange}
//                     className="form-control"
//                     placeholder="License Number"
//                   />
//                 </div>
             
//                 <div className="form-group checkbox-group">
//                   <label className="checkbox-label">
//                     <input
//                       type="checkbox"
//                       name="isActive"
//                       checked={editForm.isActive || false}
//                       onChange={handleInputChange}
//                     />
//                     <span className="checkbox-text">Active Driver</span>
//                   </label>
//                 </div>
//               </div>
//             </div>
//             <div className="modal-footer">
//               <button className="action-btn cancel" onClick={handleCancelEdit}>
//                 Cancel
//               </button>
//               <button className="action-btn save" onClick={handleSaveEdit} disabled={isFetchingDetails}>
//                 {isFetchingDetails ? 'Saving...' : 'Save Changes'}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default DriverManagement;

import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import '../../Styles/ManagementPages.css';
import '../../Styles/CustomerManage.css';
import { getDrivers, getDriverById, updateDriver } from '../../Services/Operations/ProductAPI';

// Skeleton Components
const SkeletonStatsCard = () => (
  <div className="stat-card skeleton">
    <div className="skeleton-title"></div>
    <div className="skeleton-value"></div>
    <div className="skeleton-subtitle"></div>
  </div>
);

const SkeletonTableRow = () => (
  <tr className="skeleton-row">
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-badge"></div></td>
    <td><div className="skeleton-actions"></div></td>
  </tr>
);

const SkeletonTable = () => (
  <div className="table-container skeleton">
    <table className="data-table">
      <thead>
        <tr>
          <th>No.</th>
          <th>Name</th>
          <th>Mobile</th>
          <th>License</th>
          <th>Experience</th>
          <th>Bus Owner</th>
          <th>Assigned Bus</th>
          <th>Status</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i) => (
          <SkeletonTableRow key={i} />
        ))}
      </tbody>
    </table>
  </div>
);

const SkeletonModal = () => (
  <div className="modal-overlay">
    <div className="modal-content1 skeleton-modal">
      <div className="modal-header">
        <div className="skeleton-title"></div>
        <div className="skeleton-close"></div>
      </div>
      <div className="modal-body">
        <div className="skeleton-profile-image"></div>
        {[1, 2, 3, 4, 5, 6, 7].map((i) => (
          <div key={i} className="skeleton-detail-row">
            <div className="skeleton-label"></div>
            <div className="skeleton-value"></div>
          </div>
        ))}
      </div>
      <div className="modal-footer">
        <div className="skeleton-button"></div>
      </div>
    </div>
  </div>
);

const SkeletonEditModal = () => (
  <div className="modal-overlay">
    <div className="modal-content1 edit-modal skeleton-modal">
      <div className="modal-header">
        <div className="skeleton-title"></div>
        <div className="skeleton-close"></div>
      </div>
      <div className="modal-body">
        {[1, 2, 3, 4].map((i) => (
          <div key={i} className="form-group">
            <div className="skeleton-label"></div>
            <div className="skeleton-input"></div>
          </div>
        ))}
      </div>
      <div className="modal-footer">
        <div className="skeleton-button"></div>
        <div className="skeleton-button"></div>
      </div>
    </div>
  </div>
);

const DriverManagement = () => {
  const { token } = useSelector(state => state.user);
  const [drivers, setDrivers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searching, setSearching] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [editingDriver, setEditingDriver] = useState(null);
  const [editForm, setEditForm] = useState({});
  const [viewingDriver, setViewingDriver] = useState(null);
  const [error, setError] = useState(null);
  const [isFetchingDetails, setIsFetchingDetails] = useState(false);

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalDrivers, setTotalDrivers] = useState(0);
  const [pageSize] = useState(10);

  // Calculate starting index for sequential numbering
  const getSequentialNumber = (index) => {
    return (currentPage - 1) * pageSize + index + 1;
  };

  // Fetch drivers on page or search change
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      fetchDrivers();
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [currentPage, searchTerm]);

  const fetchDrivers = async () => {
    try {
      setSearching(true);
      setLoading(true);
      const response = await getDrivers(token, currentPage, pageSize, searchTerm);

      if (response && response.drivers) {
        const transformedDrivers = response.drivers.map((driver, index) => ({
          id: driver._id,
          serialNo: getSequentialNumber(index),
          profileImage: driver.profileImage,
          name: driver.name || '',
          mobileNumber: driver.mobileNumber || '',
          licenseNumber: driver.licenseNumber || '',
          experience: driver.experience || 0,
          assignedBus: driver.assignedBus || null,
          busOwner: driver.busOwner || null,
          isActive: driver.isActive || false,
          joined: new Date(driver.createdAt).toISOString().split('T')[0],
          status: driver.isActive ? 'Active' : 'Inactive',
        }));

        setDrivers(transformedDrivers);
        setTotalPages(response.totalPages || 1);
        setTotalDrivers(response.total || 0);
      }
    } catch (err) {
      setError('Failed to fetch drivers.');
      console.error('Error fetching drivers:', err);
    } finally {
      setLoading(false);
      setSearching(false);
    }
  };

  const handleViewDriver = async (driverId) => {
    try {
      setIsFetchingDetails(true);
      setError(null);
      
      const response = await getDriverById(driverId, token);
      
      if (response.success) {
        const driver = response.data;
        setViewingDriver({
          id: driver._id,
          name: driver.name || '',
          mobileNumber: driver.mobileNumber || '',
          licenseNumber: driver.licenseNumber || '',
          experience: driver.experience || 0,
          email: driver.email || '',
          address: driver.address || '',
          isActive: driver.isActive,
          assignedBus: driver.assignedBus || null,
          busOwner: driver.busOwner || null,
          profileImage: driver.profileImage,
          createdAt: new Date(driver.createdAt).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          }),
          updatedAt: new Date(driver.updatedAt).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          })
        });
      } else {
        setError('Failed to fetch driver details.');
      }
    } catch (err) {
      console.error('Error fetching driver details:', err);
      setError('Failed to fetch driver details.');
    } finally {
      setIsFetchingDetails(false);
    }
  };

  const handleEditDriver = async (driverId) => {
    try {
      setIsFetchingDetails(true);
      setError(null);
      
      const response = await getDriverById(driverId, token);
      
      if (response.success) {
        const driver = response.data;
        setEditingDriver(driver._id);
        setEditForm({
          name: driver.name || '',
          mobileNumber: driver.mobileNumber || '',
          licenseNumber: driver.licenseNumber || '',
          experience: driver.experience || 0,
          isActive: driver.isActive || true
        });
      } else {
        setError('Failed to fetch driver details for editing.');
      }
    } catch (err) {
      console.error('Error fetching driver details for editing:', err);
      setError('Failed to fetch driver details for editing.');
    } finally {
      setIsFetchingDetails(false);
    }
  };

  const handleSaveEdit = async () => {
    try {
      setError(null);
      
      const updateData = {
        name: editForm.name,
        mobileNumber: editForm.mobileNumber,
        licenseNumber: editForm.licenseNumber,
        experience: editForm.experience,
        isActive: editForm.isActive
      };

      console.log('Updating driver with data:', updateData);
      
      const response = await updateDriver(editingDriver, updateData, token);
      
      if (response.success) {
        setDrivers(prevDrivers =>
          prevDrivers.map(driver =>
            driver.id === editingDriver ? {
              ...driver,
              name: response.data.name,
              mobileNumber: response.data.mobileNumber,
              licenseNumber: response.data.licenseNumber,
              experience: response.data.experience,
              status: response.data.isActive ? 'Active' : 'Inactive',
              isActive: response.data.isActive
            } : driver
          )
        );

        setEditingDriver(null);
        setEditForm({});
        alert('Driver updated successfully!');
      } else {
        setError(response.message || 'Failed to update driver.');
      }
    } catch (err) {
      console.error('Error updating driver:', err);
      setError(err.response?.data?.message || 'Failed to update driver. Please try again.');
      alert('Failed to update driver. Please try again.');
    }
  };

  const handleCancelEdit = () => {
    setEditingDriver(null);
    setEditForm({});
    setError(null);
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setEditForm(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const closeViewModal = () => {
    setViewingDriver(null);
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const handleRefresh = () => {
    setSearchTerm('');
    setCurrentPage(1);
  };

  const handleExportCSV = () => {
    if (drivers.length === 0) {
      alert('No data to export');
      return;
    }

    const headers = ['Serial No.', 'ID', 'Name', 'Mobile', 'License', 'Experience', 'Bus Owner', 'Assigned Bus', 'Status'];
    const csvData = drivers.map(driver => [
      driver.serialNo,
      driver.id,
      driver.name || '',
      driver.mobileNumber || '',
      driver.licenseNumber || '',
      driver.experience || '',
      driver.busOwner?.name || 'N/A',
      driver.assignedBus?.busNumber || 'Not Assigned',
      driver.status
    ]);

    const csvContent = [
      headers.join(','),
      ...csvData.map(row => row.map(field => `"${field}"`).join(','))
    ].join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `drivers-report-${new Date().toISOString().split('T')[0]}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

    alert('CSV exported successfully!');
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(prev => prev + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(prev => prev - 1);
    }
  };

  const handlePageClick = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const filteredDrivers = drivers.filter(driver =>
    (driver.name && driver.name.toLowerCase().includes(searchTerm.toLowerCase())) ||
    (driver.mobileNumber && driver.mobileNumber.includes(searchTerm)) ||
    (driver.licenseNumber && driver.licenseNumber.toLowerCase().includes(searchTerm.toLowerCase())) ||
    (driver.busOwner?.name && driver.busOwner.name.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  // Loading state with skeletons
  if (loading && drivers.length === 0) {
    return (
      <div className="management-page">
        <div className="page-header">
          <div className="skeleton-header-title"></div>
          <div className="header-actions">
            <div className="skeleton-search"></div>
            <div className="skeleton-button"></div>
            <div className="skeleton-button"></div>
          </div>
        </div>

        <div className="stats-cards">
          {[1, 2, 3, 4].map((i) => (
            <SkeletonStatsCard key={i} />
          ))}
        </div>

        <SkeletonTable />

        <div className="pagination-container">
          <div className="skeleton-pagination-info"></div>
          <div className="skeleton-pagination-controls"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="management-page">
      <div className="page-header">
        <h1>Driver Management</h1>
        <div className="header-actions">
          <div style={{ position: 'relative' }}>
            <input
              type="text"
              placeholder="Search drivers by name, mobile, license or bus owner..."
              className="search-input"
              value={searchTerm}
              onChange={handleSearchChange}
              style={{ width: "70%" }}
            />
            {searching && (
              <span style={{
                position: 'absolute', right: '10px', top: '50%',
                transform: 'translateY(-50%)', fontSize: '12px', color: '#888'
              }}>
                searching...
              </span>
            )}
          </div>
          <button className="refresh-btn" onClick={handleRefresh}>
            Refresh
          </button>
          <button className="export-btn" onClick={handleExportCSV}>
            Export CSV
          </button>
        </div>
      </div>

      {error && (
        <div className="error-message">
          {error}
        </div>
      )}

      <div className="stats-cards">
        <div className="stat-card">
          <h3>Total Drivers</h3>
          <p>{totalDrivers}</p>
          <span>All registered drivers</span>
        </div>
        <div className="stat-card">
          <h3>Active Drivers</h3>
          <p>{drivers.filter(d => d.status === 'Active').length}</p>
          <span>Active drivers</span>
        </div>
        <div className="stat-card">
          <h3>With Assigned Bus</h3>
          <p>{drivers.filter(d => d.assignedBus).length}</p>
          <span>Drivers with bus assignment</span>
        </div>
        <div className="stat-card">
          <h3>Search Results</h3>
          <p>{drivers.length}</p>
          <span>drivers found</span>
        </div>
      </div>

      <div className="table-container">
        <table className="data-table">
          <thead>
            <tr>
              <th>No.</th>
              <th>Name</th>
              <th>Mobile</th>
              <th>License</th>
              <th>Experience</th>
              <th>Bus Owner</th>
              <th>Assigned Bus</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {drivers.length > 0 ? (
              drivers.map(driver => (
                <tr key={driver.id}>
                  <td>{driver.serialNo}</td>
                  <td>
                    {editingDriver === driver.id ? (
                      <input
                        type="text"
                        name="name"
                        value={editForm.name || ''}
                        onChange={handleInputChange}
                        className="edit-input"
                        placeholder="Name"
                      />
                    ) : (
                      driver.name || 'N/A'
                    )}
                  </td>
                  <td>
                    {editingDriver === driver.id ? (
                      <input
                        type="text"
                        name="mobileNumber"
                        value={editForm.mobileNumber || ''}
                        onChange={handleInputChange}
                        className="edit-input"
                        placeholder="Mobile Number"
                      />
                    ) : (
                      driver.mobileNumber || 'N/A'
                    )}
                  </td>
                  <td>
                    {editingDriver === driver.id ? (
                      <input
                        type="text"
                        name="licenseNumber"
                        value={editForm.licenseNumber || ''}
                        onChange={handleInputChange}
                        className="edit-input"
                        placeholder="License Number"
                      />
                    ) : (
                      driver.licenseNumber || 'N/A'
                    )}
                  </td>
                  <td>
                    {editingDriver === driver.id ? (
                      <input
                        type="number"
                        name="experience"
                        value={editForm.experience || ''}
                        onChange={handleInputChange}
                        className="edit-input"
                        placeholder="Years"
                        min="0"
                      />
                    ) : (
                      `${driver.experience} years` || 'N/A'
                    )}
                  </td>
                  <td>
                    {driver.busOwner?.name || 'N/A'}
                  </td>
                  <td>
                    {driver.assignedBus ? (
                      <div className="bus-info">
                        <div><strong>{driver.assignedBus.busNumber}</strong></div>
                        <small>{driver.assignedBus.busName}</small>
                      </div>
                    ) : 'Not Assigned'}
                  </td>
                  <td>
                    {editingDriver === driver.id ? (
                      <label className="checkbox-label">
                        <input
                          type="checkbox"
                          name="isActive"
                          checked={editForm.isActive || false}
                          onChange={handleInputChange}
                        />
                        <span className="checkbox-text">
                          {editForm.isActive ? 'Active' : 'Inactive'}
                        </span>
                      </label>
                    ) : (
                      <span className={`status-badge ${driver.status ? driver.status.toLowerCase() : 'inactive'}`}>
                        {driver.status || 'Inactive'}
                      </span>
                    )}
                  </td>
                  <td>
                    {editingDriver === driver.id ? (
                      <div className="edit-actions">
                        <button className="action-btn save" onClick={handleSaveEdit} disabled={isFetchingDetails}>
                          {isFetchingDetails ? 'Saving...' : 'Save'}
                        </button>
                        <button className="action-btn cancel" onClick={handleCancelEdit} disabled={isFetchingDetails}>
                          Cancel
                        </button>
                      </div>
                    ) : (
                      <div className="action-buttons">
                        <button
                          className="action-btn view"
                          onClick={() => handleViewDriver(driver.id)}
                          disabled={isFetchingDetails}
                        >
                          {isFetchingDetails ? 'Loading...' : 'View'}
                        </button>
                        <button
                          className="action-btn edit"
                          onClick={() => handleEditDriver(driver.id)}
                          disabled={isFetchingDetails}
                        >
                          {isFetchingDetails ? 'Loading...' : 'Edit'}
                        </button>
                      </div>
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="9" className="no-data">
                  <p>No drivers found {searchTerm ? 'matching your search' : ''}.</p>
                  {searchTerm && (
                    <button className="clear-filters-link" onClick={handleRefresh}>
                      Clear search to see all drivers
                    </button>
                  )}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination Component */}
      <div className="pagination-container">
        <div className="pagination-info">
          Showing {drivers.length} of {totalDrivers} drivers
          (Page {currentPage} of {totalPages})
          {searchTerm && <span className="filtered-indicator"> • Search: "{searchTerm}"</span>}
        </div>
        <div className="pagination-controls">
          <button
            className="pagination-btn"
            onClick={handlePrevPage}
            disabled={currentPage === 1}
          >
            Previous
          </button>

          <div className="page-numbers">
            {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
              let pageNumber;
              if (totalPages <= 5) {
                pageNumber = i + 1;
              } else if (currentPage <= 3) {
                pageNumber = i + 1;
              } else if (currentPage >= totalPages - 2) {
                pageNumber = totalPages - 4 + i;
              } else {
                pageNumber = currentPage - 2 + i;
              }

              return (
                <button
                  key={pageNumber}
                  className={`page-number ${pageNumber === currentPage ? 'active' : ''}`}
                  onClick={() => handlePageClick(pageNumber)}
                >
                  {pageNumber}
                </button>
              );
            })}
          </div>

          <button
            className="pagination-btn"
            onClick={handleNextPage}
            disabled={currentPage === totalPages}
          >
            Next
          </button>
        </div>
      </div>

      {/* View Driver Modal */}
      {viewingDriver && !isFetchingDetails && (
        <div className="modal-overlay" onClick={closeViewModal}>
          <div className="modal-content1" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Driver Details</h3>
              <button className="modal-close-btn" onClick={closeViewModal}>
                ×
              </button>
            </div>
            <div className="modal-body">
              <div className="customer-details">
                <div className="customer-profile-image">
                  <img
                    src={viewingDriver.profileImage ? 
                      `${process.env.REACT_APP_BASE_URL}/uploads/${viewingDriver.profileImage}` : 
                      ''}
                    alt={viewingDriver.name || 'Driver'}
                    className="profile-image-large"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = '';
                    }}
                  />
                </div>
                <div className="detail-row">
                  <label>Name:</label>
                  <span>{viewingDriver.name || 'N/A'}</span>
                </div>
                <div className="detail-row">
                  <label>Mobile Number:</label>
                  <span>{viewingDriver.mobileNumber || 'N/A'}</span>
                </div>
                <div className="detail-row">
                  <label>License Number:</label>
                  <span>{viewingDriver.licenseNumber || 'N/A'}</span>
                </div>
                <div className="detail-row">
                  <label>Experience:</label>
                  <span>{viewingDriver.experience} years</span>
                </div>
                <div className="detail-row">
                  <label>Bus Owner:</label>
                  <span>
                    {viewingDriver.busOwner ? (
                      <div className="bus-owner-info">
                        <strong>{viewingDriver.busOwner.name}</strong>
                        <small>{viewingDriver.busOwner.phone}</small>
                      </div>
                    ) : 'N/A'}
                  </span>
                </div>
                <div className="detail-row">
                  <label>Assigned Bus:</label>
                  <span>
                    {viewingDriver.assignedBus ? (
                      <div className="bus-info">
                        <strong>{viewingDriver.assignedBus.busNumber}</strong>
                        <small>{viewingDriver.assignedBus.busName}</small>
                      </div>
                    ) : 'Not Assigned'}
                  </span>
                </div>
                <div className="detail-row">
                  <label>Created Date:</label>
                  <span>{viewingDriver.createdAt}</span>
                </div>
                <div className="detail-row">
                  <label>Last Updated:</label>
                  <span>{viewingDriver.updatedAt}</span>
                </div>
                <div className="detail-row">
                  <label>Status:</label>
                  <span className={`status-badge ${viewingDriver.isActive ? 'active' : 'inactive'}`}>
                    {viewingDriver.isActive ? 'Active' : 'Inactive'}
                  </span>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button className="modal-close-btn secondary" onClick={closeViewModal}>
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Loading state for view modal */}
      {viewingDriver && isFetchingDetails && <SkeletonModal />}

      {/* Edit Form Modal */}
      {editingDriver && !isFetchingDetails && (
        <div className="modal-overlay" onClick={handleCancelEdit}>
          <div className="modal-content1 edit-modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Edit Driver</h3>
              <button className="modal-close-btn" onClick={handleCancelEdit}>
                ×
              </button>
            </div>
            <div className="modal-body">
              <div className="edit-form">
                <div className="form-group">
                  <label>Name:</label>
                  <input
                    type="text"
                    name="name"
                    value={editForm.name || ''}
                    onChange={handleInputChange}
                    className="form-control"
                    placeholder="Driver Name"
                  />
                </div>
                <div className="form-group">
                  <label>Mobile Number:</label>
                  <input
                    type="text"
                    name="mobileNumber"
                    value={editForm.mobileNumber || ''}
                    onChange={handleInputChange}
                    className="form-control"
                    placeholder="Mobile Number"
                  />
                </div>
                <div className="form-group">
                  <label>License Number:</label>
                  <input
                    type="text"
                    name="licenseNumber"
                    value={editForm.licenseNumber || ''}
                    onChange={handleInputChange}
                    className="form-control"
                    placeholder="License Number"
                  />
                </div>
                <div className="form-group">
                  <label>Experience (years):</label>
                  <input
                    type="number"
                    name="experience"
                    value={editForm.experience || ''}
                    onChange={handleInputChange}
                    className="form-control"
                    placeholder="Years of experience"
                    min="0"
                    step="0.5"
                  />
                </div>
                <div className="form-group checkbox-group">
                  <label className="checkbox-label">
                    <input
                      type="checkbox"
                      name="isActive"
                      checked={editForm.isActive || false}
                      onChange={handleInputChange}
                    />
                    <span className="checkbox-text">Active Driver</span>
                  </label>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button className="action-btn cancel" onClick={handleCancelEdit}>
                Cancel
              </button>
              <button className="action-btn save" onClick={handleSaveEdit}>
                Save Changes
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Loading state for edit modal */}
      {editingDriver && isFetchingDetails && <SkeletonEditModal />}
    </div>
  );
};

export default DriverManagement;